import LoginModal from "../Auth/LoginModal";
import RegisterModal from "../Auth/RegisterModal";
import Footer from "./Footer";
import Navbar from "./Navbar";

const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-surface-50">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <LoginModal />
    <RegisterModal />
  </div>
);

export default Layout;
